'use strict';

/**
 * @ngdoc function
 * @name courseApp.controller:CheckController
 * @description
 * # CheckController
 * Controller of the courseApp
 */
angular.module('courseApp')
    .controller('CheckController', function ($filter, ActCourseService, APIs, ConfigService) {
        var vm = this;
        vm.selectedGroupDay = undefined;
        // vm.attendeesLoaded = false;
        // vm.hrAttendeesLoaded = false;

        // load all attendees of the course
        vm.loadAttendeeList = function () {
            vm.attendeeList = [];
            APIs.AttendeeService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (attendee) {
                    vm.attendeeList.push(attendee);
                });
                vm.updateAttendeeRemarkLift();
                vm.loadHotelRoomAttendees();
            });
        };

        vm.updateAttendeeRemarkLift = function () {
            vm.attendeeRemarkLift = [];

            angular.forEach(vm.attendeeList, function (a) {
                if (angular.isDefined(a.remark_lift_pass) && a.remark_lift_pass.length >= 1) {
                    vm.attendeeRemarkLift.push(a);
                }
            });
            vm.tableParamsAttendeeLift.settings({
                dataset: vm.attendeeRemarkLift
            });
        };

        vm.loadHotelRoomAttendees = function () {
            vm.hotelRoomAttendeeList = [];
            vm.selManyHotelAttendee = undefined;

            APIs.HotelRoomAttendeesService.query({ hotel_room__hotel__course: vm.selectedCourse.id }).$promise.then(function (hra) {
                angular.forEach(hra, function (hotelRoomAttendee) {
                    vm.hotelRoomAttendeeList.push(hotelRoomAttendee);
                });
                vm.updateAttendeeNoHotelList(vm.hotelRoomAttendeeList);
                vm.updateAttendeeManyHotelList(vm.hotelRoomAttendeeList);
            });
        };

        vm.updateAttendeeNoHotelList = function (hotelRoomAttendees) {
            vm.attendeeNoHotelList = angular.copy(vm.attendeeList);

            angular.forEach(hotelRoomAttendees, function (hra) {
                var del = $filter('filter')(vm.attendeeNoHotelList, { id: hra.attendee }, true);
                if (angular.isDefined(del)) {
                    vm.attendeeNoHotelList.splice(vm.attendeeNoHotelList.indexOf(del[0]), 1);
                }
            });
            vm.tableParamsHotel.settings({
                dataset: vm.attendeeNoHotelList
            });
        };

        vm.updateAttendeeManyHotelList = function (hotelRoomAttendees) {
            vm.attendeeManyHotelList = angular.copy(vm.attendeeList);

            angular.forEach(vm.attendeeList, function (a) {
                var del = $filter('filter')(hotelRoomAttendees, { attendee: a.id }, true);
                var delA;
                if (angular.isUndefined(del) || del.length === 0) {
                    delA = $filter('filter')(vm.attendeeManyHotelList, { id: a.id }, true);
                    vm.attendeeManyHotelList.splice(vm.attendeeManyHotelList.indexOf(delA[0]), 1);
                } else if (del.length === 1) {
                    delA = $filter('filter')(vm.attendeeManyHotelList, { id: a.id }, true);
                    vm.attendeeManyHotelList.splice(vm.attendeeManyHotelList.indexOf(delA[0]), 1);
                }
            });
            vm.tableParamsManyHotel.settings({
                dataset: vm.attendeeManyHotelList
            });
        };

        vm.setManyHotelAttendee = function (selAttendee) {
            vm.selManyHotelAttendee = selAttendee;
            vm.manyHotelRooms = [];
            var hrs = $filter('filter')(vm.hotelRoomAttendeeList, { attendee: selAttendee.id }, true);

            angular.forEach(hrs, function (hr) {
                APIs.HotelRoomService.get({ id: hr.hotel_room }).$promise.then(function (hotelRoom) {
                    APIs.CourseHotelService.get({ id: hotelRoom.hotel }).$promise.then(function (hotel) {
                        vm.manyHotelRooms.push({ hotel: hotel.hotel, hotel_room: hotelRoom });
                    });
                });
            });
        };

        // load all groups of the course
        vm.loadGroupList = function () {
            vm.groupDays = [];
            APIs.GroupService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (group) {
                    var existingDay = $filter('filter')(vm.groupDays, { day: group.day });
                    if (existingDay.length === 0) {
                        vm.groupDays.push({ name: group.day, day: group.day });
                    }
                });
            });
        };

        // load all attendees of the groups of the selected day
        vm.loadGroupAttendeeList = function () {
            vm.groupAttendeeList = [];
            vm.selDupAttendee = undefined;
            vm.dupAttendeeGroups = [];
            APIs.GroupAttendeeService.query({ group__course: vm.selectedCourse.id, group__day: vm.selectedGroupDay.day }).$promise.then(function (data) {
                angular.forEach(data, function (ga) {
                    vm.groupAttendeeList.push(ga);
                });
                vm.updateAttendeeNoGroupList();
                vm.updateAttendeeDuplicateGroupList();
            });
        };

        vm.updateAttendeeNoGroupList = function () {
            vm.attendeeNoGroupList = angular.copy(vm.attendeeList);

            angular.forEach(vm.groupAttendeeList, function (ga) {
                var del = $filter('filter')(vm.attendeeNoGroupList, { id: ga.attendee }, true);
                if (angular.isDefined(del) && del.length === 1) {
                    vm.attendeeNoGroupList.splice(vm.attendeeNoGroupList.indexOf(del[0]), 1);
                }
            });
            vm.tableParamsNoGroup.settings({
                dataset: vm.attendeeNoGroupList
            });
        };

        vm.updateAttendeeDuplicateGroupList = function () {
            vm.attendeeDuplicateGroupList = angular.copy(vm.attendeeList);

            angular.forEach(vm.attendeeList, function (a) {
                var del = $filter('filter')(vm.groupAttendeeList, { attendee: a.id }, true);
                var delA;
                if (angular.isUndefined(del) || del.length === 0) {
                    delA = $filter('filter')(vm.attendeeDuplicateGroupList, { id: a.id }, true);
                    vm.attendeeDuplicateGroupList.splice(vm.attendeeDuplicateGroupList.indexOf(delA[0]), 1);
                } else if (del.length === 1) {
                    delA = $filter('filter')(vm.attendeeDuplicateGroupList, { id: a.id }, true);
                    vm.attendeeDuplicateGroupList.splice(vm.attendeeDuplicateGroupList.indexOf(delA[0]), 1);
                }
            });

            vm.tableParamsDuplicateGroup.settings({
                dataset: vm.attendeeDuplicateGroupList
            });
        };

        vm.colsAttendeeLift = [
            { valueExpr: 'attendee.person.name', title: 'Name', sortable: 'person.name', filter: { 'person.name': 'text' }, show: true },
            { valueExpr: 'attendee.person.first_name', title: 'Vorname', sortable: 'person.first_name', filter: { 'person.first_name': 'text' }, show: true },
            { valueExpr: 'attendee.remark_lift_pass', title: 'Bemerkung (Liftkarte)', show: true }
        ];

        vm.tableParamsAttendeeLift = new ConfigService.NgTableParams({ page: 1, count: 10 }, {
            defaultSelectValue: 'Show all',
            counts: [],
            dataset: vm.attendeeRemarkLift
        });

        vm.colsHotel = [
            { valueExpr: 'attendee.person.name', title: 'Name', sortable: 'person.name', filter: { 'person.name': 'text' }, show: true },
            { valueExpr: 'attendee.person.first_name', title: 'Vorname', sortable: 'person.first_name', filter: { 'person.first_name': 'text' }, show: true },
            { valueExpr: 'attendee.person.birthday | date:\'dd.MM.yyyy\'', title: 'GebDatum', show: true },
            { valueExpr: 'attendee.person.lsv.short_name', title: 'LSV', sortable: 'person.lsv.short_name', show: true },
            { valueExpr: 'attendee.type', title: 'Art', sortable: 'type', filter: { type: 'select' }, filterData: ConfigService.ATTENDEE_TYPE, show: true }
        ];

        vm.tableParamsHotel = new ConfigService.NgTableParams({ page: 1, count: 10 }, {
            defaultSelectValue: 'Show all',
            counts: [],
            dataset: vm.attendeeNoHotelList
        });

        vm.colsManyHotel = angular.copy(vm.colsHotel);

        vm.tableParamsManyHotel = new ConfigService.NgTableParams({ page: 1, count: 10 }, {
            defaultSelectValue: 'Show all',
            counts: [],
            dataset: vm.attendeeManyHotelList
        });

        vm.colsNoGroup = [
            { valueExpr: 'attendee.person.name', title: 'Name', sortable: 'person.name', filter: { 'person.name': 'text' }, show: true },
            { valueExpr: 'attendee.person.first_name', title: 'Vorname', sortable: 'person.first_name', filter: { 'person.first_name': 'text' }, show: true },
            { valueExpr: 'attendee.person.birthday | date:\'dd.MM.yyyy\'', title: 'GebDatum', show: true },
            { valueExpr: 'attendee.person.lsv.short_name', title: 'LSV', sortable: 'person.lsv.short_name', show: true },
            { valueExpr: 'attendee.type', title: 'Art', sortable: 'type', filter: { type: 'select' }, filterData: ConfigService.ATTENDEE_TYPE, show: true },
            { valueExpr: 'attendee.person.lizenz', title: 'Stufe', sortable: 'person.lizenz', filter: { 'person.lizenz': 'text' }, show: true }
        ];

        vm.tableParamsNoGroup = new ConfigService.NgTableParams({ page: 1, count: 10 }, {
            defaultSelectValue: 'Show all',
            counts: [],
            dataset: undefined
        });

        vm.colsDuplicateGroup = angular.copy(vm.colsNoGroup);
        vm.tableParamsDuplicateGroup = angular.copy(vm.tableParamsNoGroup);

        vm.setSelectedDuplicateAttendee = function (selAttendee) {
            vm.selDupAttendee = selAttendee;
            vm.dupAttendeeGroups = [];
            var gas = $filter('filter')(vm.groupAttendeeList, { attendee: selAttendee.id }, true);

            angular.forEach(gas, function (ga) {
                APIs.GroupService.get({ id: ga.group }).$promise.then(function (data) {
                    vm.dupAttendeeGroups.push(data);
                });
            });
        };

        vm.selectedCourse = ActCourseService.getActCourse();
        if (angular.isDefined(vm.selectedCourse)) {
            vm.loadAttendeeList();
            vm.loadGroupList();
        }
    });
